// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"f003f7ae","111":"ebfb6544","136":"31092b08","193":"a6fc8df6","345":"c7eeff9d","488":"4c7ed992","855":"3433255f"}[chunkId] + ".chunk.js";
};